import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ColorModeProvider from "./theme/ColorModeProvider";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router } from "react-router-dom"; // Import Router
import { initAmplitude } from "./analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      <Router>
        {/* Wrap the App component with Router */}
        <App />
        <ToastContainer />
      </Router>
    </ColorModeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
initAmplitude();
